module.exports = __webpack_public_path__ + "media/nicole4.3d10a1ea.mp3";